import { render, staticRenderFns } from "./AdminStreetsAdd.vue?vue&type=template&id=0263ad14&"
import script from "./AdminStreetsAdd.vue?vue&type=script&lang=js&"
export * from "./AdminStreetsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports